import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const SUPPORT_EMAIL = "thenerdydermy@icloud.com";

export default function Contact() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="contact-page">
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="contact-home-link">
            <img src="/azordi-logo.webp" alt="azordi" className="h-8 w-auto" />
          </Link>
          <Link to="/" className="text-sm text-muted-foreground hover:text-foreground">Back to home</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">Contact us</h1>
        <p className="text-muted-foreground mt-3 leading-relaxed">
          Questions, feedback or need a hand? Email us and we'll reply as soon as we can — usually within 1 business day.
        </p>

        <div className="mt-8 space-y-6">
          <div className="flex items-start gap-3" data-testid="contact-email">
            <Mail className="h-5 w-5 text-primary mt-0.5" />
            <div>
              <div className="font-heading font-semibold text-sm">Email</div>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary hover:underline" data-testid="contact-email-link">{SUPPORT_EMAIL}</a>
            </div>
          </div>
          <div className="flex items-start gap-3" data-testid="contact-address">
            <MapPin className="h-5 w-5 text-primary mt-0.5" />
            <div>
              <div className="font-heading font-semibold text-sm">The Nerdy Dermy</div>
              <p className="text-sm text-muted-foreground leading-relaxed">Chameleon Drive<br />Erskine Park NSW<br />Australia</p>
            </div>
          </div>
        </div>

        <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="contact-email-button"
           className="mt-10 inline-flex items-center gap-2 rounded-xl bg-primary text-primary-foreground px-5 py-3 font-medium hover:opacity-90 transition-opacity">
          <Mail className="h-4 w-4" /> Email us · {SUPPORT_EMAIL}
        </a>
      </main>

      <footer className="border-t border-border">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 text-center text-sm text-muted-foreground">
          The Nerdy Dermy · Erskine Park NSW, Australia · <Link to="/support" className="hover:text-foreground">Support</Link> · <Link to="/privacy" className="hover:text-foreground">Privacy</Link> · <Link to="/terms" className="hover:text-foreground">Terms</Link>
        </div>
      </footer>
    </div>
  );
}
